import React from "react";

const AboutUs = () => {
  return (
    <section class="bg-gray-900 py-20">
      <div class="max-w-6xl mx-auto px-8">
        <div class="flex flex-col md:flex-row">
          <div class="w-full md:w-1/2">
            <h2 class="text-3xl lg:text-5xl font-bold text-white mb-8">
              About Us
            </h2>
            <p class="text-white text-lg mb-8 lg:mr-5">
              EduGenius is a platform that connects students with highly
              qualified tutors for personalized, one-on-one online tutoring
              sessions. Our tutors are experts in various subjects and have
              years of experience in teaching. We believe that every student
              deserves access to quality education, regardless of their location
              or financial situation.
            </p>
            <p class="text-white text-lg mb-8 lg:mr-5">
              Our mission is to make learning accessible and enjoyable for
              everyone. We strive to provide the best online tutoring experience
              to our students by offering personalized, engaging, and effective
              tutoring sessions. We are committed to helping our students
              achieve their academic goals and reach their full potential.
            </p>
          </div>
          <div class="w-full md:w-1/2 flex justify-center items-center">
            {/* <img
              src="https://source.unsplash.com/random/500x500"
              alt="About Us"
              class="rounded-full w-3/4 md:w-2/3 lg:w-1/2"
            /> */}
            <img
              src="https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=600"
              alt="About Us"
              class="w-full px-5 rounded-[6%] h-96"
            />
          </div>
        </div>
      </div>
      <section class="bg-gray-900 pt-10">
        <div class="max-w-5xl mx-auto px-6 lg:px-8 flex flex-col items-center">
          <div class="grid grid-cols-4 gap-6 lg:gap-8 text-white">
            <div class="countdown-item flex flex-col items-center">
              <span class="text-white font-bold text-3xl md:text-4xl lg:text-5xl">
                307
              </span>
              <span class="text-white text-sm md:text-base lg:text-lg text-center">
                Finished Sessions
              </span>
            </div>

            <div class="countdown-item flex flex-col items-center">
              <span class="text-white font-bold text-3xl md:text-4xl lg:text-5xl">
                5628
              </span>
              <span class="text-white text-sm md:text-base lg:text-lg text-center">
                Enrolled Learners
              </span>
            </div>
            <div class="countdown-item flex flex-col items-center">
              <span class="text-white font-bold text-3xl md:text-4xl lg:text-5xl">
                54
              </span>
              <span class="text-white text-sm md:text-base lg:text-lg text-center">
                Online Instructors
              </span>
            </div>
            <div class="countdown-item flex flex-col items-center">
              <span class="text-white font-bold text-3xl md:text-4xl lg:text-5xl">
                95%
              </span>
              <span class="text-white text-sm md:text-base lg:text-lg text-center">
                Satisfaction Rate
              </span>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default AboutUs;
